import { useLayoutEffect, useRef, useState } from "react";
export function useRefScrollProgress(inputRef) {
    const ref = useRef();
    const [start, setStart] = useState(null);
    const [end, setEnd] = useState(null);
    useLayoutEffect(() => {
        if (!ref.current && !inputRef.current) {
            return;
        }
        const usedRef = ref.current || inputRef.current;
        const rect = usedRef.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop;
        setStart(offsetTop);
        setEnd(offsetTop + rect.height);
    });
    return { ref, start, end };
}
//# sourceMappingURL=getRefScrollProgress.js.map